export const SourceCoreInfoRequest = "coreinforequests";
export const SourceCoreInfoRequestDetailList = "coreinforequestdetails";

export const TitleCoreInfoRequest = {
  list: "Core Info Request List",
  edit: "Core Info Request Edit ",
  create: "Create Core Info Request",
};
